/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Meta_TitleInputs */

const es_tyc_meta_title = /** @type {(inputs: Tyc_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Terminos y Condiciones`)
};

const en_tyc_meta_title = /** @type {(inputs: Tyc_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Terms and Conditions`)
};

/**
* | output |
* | --- |
* | "Nexata \| Terms and Conditions" |
*
* @param {Tyc_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_meta_title = /** @type {((inputs?: Tyc_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_meta_title(inputs)
	return en_tyc_meta_title(inputs)
});
export { tyc_meta_title as "tyc.meta.title" }